import React from 'react';

interface FlippableCardProps {
    frontContent: React.ReactNode;
    backContent: React.ReactNode;
    className?: string;
}

/**
 * A reusable component that creates a 3D flipping card effect on hover.
 *
 * It's built to be 100% SEO-friendly. Both the front and back content
 * are always rendered in the HTML DOM. CSS is used to visually show only
 * one side at a time, but crawlers can see and index all content.
 */
const FlippableCard: React.FC<FlippableCardProps> = ({ frontContent, backContent, className = '' }) => {
    return (
        <div className={`flip-card-container ${className}`}>
            <div className="flip-card-inner">
                <div className="flip-card-front">
                    {frontContent}
                </div>
                <div className="flip-card-back">
                    {backContent}
                </div>
            </div>
        </div>
    );
};

export default FlippableCard;
